import React from "react"
import facebook from "../../assets/images/facebook.png"
import twitter from "../../assets/images/twitter.png"
import instagram from "../../assets/images/instagram.png"
import phone from "../../assets/images/phone.png"
import email from "../../assets/images/email.png"
import location from "../../assets/images/location.png"
// import '../../scss/style/footer.scss'


const Footer=()=>{
    return(
        <div className="footer">
            <div className="upper-line line"></div>
            <div className="content">
                <div className="footer-div">
                    <div className="footer-title">Home</div>
                    <div className="footer-text">
                        <div>Home</div>
                        <div>About Us Tour</div>
                        <div>Packages</div>
                    </div>
                </div>
                <div className="footer-div">
                    <div className="footer-title">Help</div>
                    <div className="footer-text">
                        <div>Term of Use</div>
                        <div>Provicy Policy</div>
                    </div>
                </div>
                <div className="footer-div">
                    <div className="footer-title">Contacts</div>
                    <div className="footer-contacts">
                        <div className="footer-contacts-content">
                            <img src={location} className="footer-icon"></img>
                            <text className="footer-text">Lorem ipsum dolor sit amet</text>
                        </div>
                        <div className="footer-contacts-content">
                            <img src={phone} className="footer-icon"></img>
                            <text className="footer-text">+39 946 968 5708</text>
                        </div>
                        <div className="footer-contacts-content">
                            <img src={email} className="footer-icon"></img>
                            <text className="footer-text">Egypttour@gmail.com</text>
                        </div>
                    </div>
                </div>
                <div className="footer-div">
                    <div className="footer-title">Social Media</div>
                    <div className="footer-social">
                        <img src={twitter} className="footer-icon-social"></img>
                        <img src={facebook} className="footer-icon-social"></img>
                        <img src={instagram} className="footer-icon-social"></img>
                    </div>
                </div>

            </div>

            <div className="lower-line line"></div>

            <div className="footer-bottom">
                <text>Copyright © 2024.  All rights reserved.</text>
            </div>
        </div>
    )
}
export default Footer;